import { BaseApiService } from "@mirage/services/BaseApiService";
import { IBcCompetentPersonSchema } from "@shared/publicportal/entities/IBcCompetentPersonSchema";
import { IEntityPageRequest } from "@shared/mirage/core/contracts/IEntityPageRequest";
import { IEntityPageResult } from "@shared/mirage/core/contracts/IEntityPageResult";
import { ICompetentPersonsSchemeService } from "@shared/publicportal/services/ICompetentPersonsSchemeService";

export default class CompetentPersonsSchemeService extends BaseApiService implements ICompetentPersonsSchemeService {
    constructor() {
        super("publicportal/competentPersonsScheme");
    }

    async getSchemeById(id: number): Promise<IBcCompetentPersonSchema> {
        const response = await this.httpInstance().get(`/${id}`);
        return response.data;
    }

    async pageRequest(pr: IEntityPageRequest): Promise<IEntityPageResult<IBcCompetentPersonSchema>> {
        const response = await this.httpInstance().post("/pageRequest", pr);
        return response.data;
    }
}
